/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import address from "../http/requests/address";
import Helpers from "../utils/helpers";

const actions = {
	// /////////////////////////////////////////////
	// COMPONENTS
	// /////////////////////////////////////////////

	// Vertical NavMenu
	updateVerticalNavMenuWidth({ commit }, width) {
		commit("UPDATE_VERTICAL_NAV_MENU_WIDTH", width);
	},

	// VxAutoSuggest
	updateStarredPage({ commit }, payload) {
		commit("UPDATE_STARRED_PAGE", payload);
	},

	// The Navbar
	arrangeStarredPagesLimited({ commit }, list) {
		commit("ARRANGE_STARRED_PAGES_LIMITED", list);
	},
	arrangeStarredPagesMore({ commit }, list) {
		commit("ARRANGE_STARRED_PAGES_MORE", list);
	},

	// /////////////////////////////////////////////
	// UI
	// /////////////////////////////////////////////

	toggleContentOverlay({ commit }) {
		commit("TOGGLE_CONTENT_OVERLAY");
	},
	updateTheme({ commit }, val) {
		commit("UPDATE_THEME", val);
	},

	// /////////////////////////////////////////////
	// User/Account
	// /////////////////////////////////////////////

	updateUserInfo({ commit }, payload) {
		commit("UPDATE_USER_INFO", payload);
	},
	updateUserRole({ dispatch }, payload) {
		// Change client side
		payload.aclChangeRole(payload.userRole);

		// Make API call to server for changing role

		// Change userInfo in localStorage and store
		dispatch("updateUserInfo", { userRole: payload.userRole });
	},
	getProvince({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				address
					.getProvince(payload)
					.then(response => {
						if (response.data && response.data.error_code !== 0) {
							throw response.data.error_message;
						} else {
							let finalAdds = Helpers.baseLocalSort(response.data.data.addresses, "nameNonAccent");
							commit("UPDATE_PROVINCE", finalAdds);
							resolve(finalAdds);
						}
					})
					.catch(error => {
						reject(error);
					});
			});
		} catch (error) {
			console.error("[getProvince]", error);
		}
	},
	getDistrict({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				address
					.getDistrict(payload)
					.then(response => {
						if (response.data && response.data.error_code !== 0) {
							throw response.data.error_message;
						} else {
							let finalAdds = Helpers.baseLocalSort(response.data.data.addresses, "nameNonAccent");
							commit("UPDATE_DISTRICT", finalAdds);
							resolve(finalAdds);
						}
					})
					.catch(error => {
						reject(error);
					});
			});
		} catch (error) {
			console.error("[getDistrict]", error);
		}
	},
	getWard({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				address
					.getWard(payload)
					.then(response => {
						if (response.data && response.data.error_code !== 0) {
							throw response.data.error_message;
						} else {
							let finalAdds = Helpers.baseLocalSort(response.data.data.addresses, "nameNonAccent");
							commit("UPDATE_WARD", finalAdds);
							resolve(finalAdds);
						}
					})
					.catch(error => {
						reject(error);
					});
			});
		} catch (error) {
			console.error("[getWard]", error);
		}
	}
};

export default actions;
